import { isEmpty, isNil, map } from 'ramda';
import { toastr } from 'react-redux-toastr';
import { I18n } from 'src/translations/i18n';

import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';
import { loadExcelExport } from './excelActions';

export const REQUEST = 'LOAD_MACHINE_TIMES_REQUEST';
export const SUCCESS = 'LOAD_MACHINE_TIMES_SUCCESS';
export const FAIL = 'LOAD_MACHINE_TIMES_FAIL';

const loadMachineTimesRequest = () => ({ type: REQUEST });
const loadMachineTimesSuccess = (machineTimes) => ({ type: SUCCESS, machineTimes });
const loadMachineTimesFail = (error) => ({ type: FAIL, error });

const checkValue = (val) => (val || '');

export const loadMachineTimes = (obj) => (dispatch) => {
  dispatch(loadMachineTimesRequest());
  return communicate({
    url: 'MachineTimes',
    method: 'get',
    getParams: Utils.objects.getQueryStringFromObject(map(checkValue, obj))
  }).then(({ data }) => {
    if (isNil(data.Data.MachineTimes) || isEmpty(data.Data.MachineTimes)) {
      toastr.error(I18n.t('NoDataAvailable'));
      dispatch(loadMachineTimesSuccess([]));
    }
    dispatch(loadMachineTimesSuccess(data.Data.MachineTimes));
  }).catch((error) => {
    dispatch(loadMachineTimesFail(error));
    toastrError(error);
  });
};

export const loadExcel = (params) => (dispatch) => {
  const request = {
    url: 'MachineTimes/MachineTimesExcel',
    query: Utils.objects.getQueryStringFromObject(map(checkValue, params))
  };
  return dispatch(loadExcelExport(request));
};
